import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  DASHBOARD_NB_JOBS,
  DASHBOARD_NB_JOBS_REFRESH,
  USER_NAME,
} from '../../../shared/const/Routes/statePaths';
import { getSafe } from '../../../shared/utility';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import {
  getNBJobs,
  setRefreshNBJobs,
} from '../../../store/actions/dashboard/dashboard';
import LoadingOverlay from '../../../components/UI/LoadingOverlay/LoadingOverlay';
import { openNBJobVNCDisplay } from '../../../store/actions/netbatchJobs/netbatchJobs';

const columns = onOpenVNCClick => [
  {
    field: 'Jobid',
    headerName: 'Job ID',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'JobName',
    headerName: 'Job Name',
    flex: 2,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'Status',
    headerName: 'Status',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'Progress',
    headerName: 'Progress',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'Display',
    headerName: 'Display',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'StartTime',
    headerName: 'Start Time',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'EndTime',
    headerName: 'End Time',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'action',
    headerName: 'Action',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: params => (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={e => {
          e.stopPropagation();
          onOpenVNCClick(params.row);
        }}
      >
        Open VNC
      </Button>
    ),
  },
];

const NBJobsTable = () => {
  const dispatch = useDispatch();
  const rows = useSelector(state => getSafe(DASHBOARD_NB_JOBS, state));
  const [loading, setLoading] = useState(false);

  const userName = useSelector(state => getSafe(USER_NAME, state));
  const refresh = useSelector(state =>
    getSafe(DASHBOARD_NB_JOBS_REFRESH, state)
  );

  useEffect(() => {
    setLoading(true);
    dispatch(getNBJobs(userName));
  }, []);

  useEffect(() => {
    setLoading(false);
  }, [rows]);

  useEffect(() => {
    if (refresh) {
      dispatch(setRefreshNBJobs(false));
      setLoading(true);
      dispatch(getNBJobs(userName));
    }
  }, [refresh]);

  const handleOpenVNC = row => {
    dispatch(openNBJobVNCDisplay(row));
  };

  return (
    <LoadingOverlay loading={loading}>
      <DataGrid
        rows={rows}
        columns={columns(handleOpenVNC)}
        getRowId={row => row.Jobid}
        hideFooter
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
      />
    </LoadingOverlay>
  );
};

export default NBJobsTable;
